export enum NoteSubCategoryType {
    Lot = 1,
    JobPlanOption = 15,
    ScheduleTask = 16
}